import { render } from "./TheLogin.vue?vue&type=template&id=565cdd3f&scoped=true"
import script from "./TheLogin.vue?vue&type=script&lang=js"
export * from "./TheLogin.vue?vue&type=script&lang=js"

import "./TheLogin.vue?vue&type=style&index=0&id=565cdd3f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565cdd3f"]])

export default __exports__